import './App.css';
import Main from './Main.js';

function App() {
  // Scroll handling now lives in <ScrollRestoration>, which resets on every
  // route change rather than only on first mount.
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
